module.exports = __webpack_public_path__ + "static/media/post15.91ab2be7.PNG";